<template>
	<vx-card :title='$t("Clients")'>
		<vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="clients">

			<div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

				<div class="flex flex-wrap-reverse items-center">
					<vs-button v-if="$checkPermission(302)" type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addClientPrompt = true">{{$t("Add")}}</vs-button>
				</div>

				<vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
					<div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
						<span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ clients.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : clients.length }} of {{ clients.length }}</span>
						<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
					</div>

					<vs-dropdown-menu>

						<vs-dropdown-item @click="itemsPerPage=10">
							<span>10</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=20">
							<span>20</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=50">
							<span>50</span>
						</vs-dropdown-item>
						<vs-dropdown-item @click="itemsPerPage=100">
							<span>100</span>
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>
			</div>

			<template slot="thead">
				<vs-th sort-key="name">{{$t("Name")}}</vs-th>
				<vs-th sort-key="vat">{{$t("VATNumber")}}</vs-th>
				<vs-th sort-key="hours">{{$t("ContractHours")}}</vs-th>
				<vs-th sort-key="email">{{$t("Email")}}</vs-th>
				<vs-th sort-key="phone">{{$t("PhoneNumber")}}</vs-th>
				<vs-th sort-key="address">{{$t("Address")}}</vs-th>
				<vs-th sort-key="country">{{$t("Country")}}</vs-th>
			</template>

			<template slot-scope="{data}">
				<tbody>
				<vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

					<vs-td :data="data[index].name">
						{{ data[index].name }}
					</vs-td>

					<vs-td :data="data[index].vat">
						{{ data[index].vat }}
					</vs-td>

					<vs-td :data="data[index].service_hours">
						{{ data[index].service_hours }}
					</vs-td>

					<vs-td :data="data[index].contact_mail">
						{{ data[index].contact_mail }}
					</vs-td>

					<vs-td :data="data[index].contact_phone">
						{{ data[index].contact_phone }}
					</vs-td>

					<vs-td :data="data[index].address">
						{{ data[index].address }}
					</vs-td>

					<vs-td :data="data[index].country">
						{{ data[index].country }}
					</vs-td>

				</vs-tr>
				</tbody>
			</template>

		</vs-table>

		<vs-popup :title="$t('Add')" :active.sync="addClientPrompt">
			<div>

				<p>{{$t("VATNumber")}}</p>
				<vx-input-group>
					<template slot="prepend">
						<div class="prepend-text btn-addon">
							<vs-button color="primary" icon-pack="feather" icon="icon-search" @click="findCompany"></vs-button>
						</div>
					</template>

					<vs-input v-model="addVAT" />
				</vx-input-group>
				<p class="mt-6">{{$t("Name")}}</p>
				<vs-input v-model="addName" style="width: 100%"></vs-input>
				<p class="mt-6">{{$t("Address")}}</p>
				<vs-input v-model="addAddress" style="width: 100%"></vs-input>
				<p class="mt-6">{{$t("Country")}}</p>
				<vs-input v-model="addCountry" style="width: 100%"></vs-input>
				<p class="mt-6">{{$t("Email")}}</p>
				<vs-input v-model="addEmail" style="width: 100%"></vs-input>
				<p class="mt-6">{{$t("PhoneNumber")}}</p>
				<vs-input v-model="addPhone" style="width: 100%"></vs-input>
				<p class="mt-6">{{$t("ContractHours")}}</p>
				<vs-input v-model="addHours" style="width: 100%"></vs-input>
				<vs-divider/>
				<vs-button color="success" type="border" class="mt-6; mr-1" @click="addClient">{{$t("Add")}}</vs-button>
			</div>
		</vs-popup>
	</vx-card>
</template>
<script>

	export default {
		data() {
			return {
				selected: {},
				clients: [],
				itemsPerPage: 20,
				isMounted: false,
				addClientPrompt: false,

				addVAT: '',
				addName: '',
				addAddress: '',
				addCountry: '',
				addEmail: '',
				addPhone: '',
				addHours: ''
			}
		},
		computed: {
			currentPage() {
				if(this.isMounted) {
					return this.$refs.table.currentx
				}
				return 0
			},
		},
		methods: {
			handleSelected(tr) {
				this.$router.push({ name: 'client', params: { id: tr.id } })
			},
			updateClients() {
				const thisIns = this;
				this.$http.get('/api/v1/client/')
						.then(function (response) {
							thisIns.clients = response.data;
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			findCompany() {
				const thisIns = this;
				this.$http.get('/api/v1/vat/' + this.addVAT)
						.then(function (response) {
							thisIns.addName = response.data.name;
							thisIns.addAddress = response.data.address;
							thisIns.addCountry = response.data.country;
						})
						.catch(function (error) {
							thisIns.$vs.notify({
								title:'Error',
								text: error,
								color:'danger',
								iconPack: 'feather',
								icon:'icon-alert-circle'})
						});
			},
			addClient() {
				const thisIns = this;
				this.$http.post('/api/v1/client/', {
					name: thisIns.addName,
					vat: thisIns.addVAT,
					address: thisIns.addAddress,
					country: thisIns.addCountry,
					service_hours: Number(thisIns.addHours),
					contact_mail: thisIns.addEmail,
					contact_phone: thisIns.addPhone
				}).then(function () {
					thisIns.updateClients();
					thisIns.addClientPrompt = false;

					thisIns.addName = "";
					thisIns.addVAT = "";
					thisIns.addAddress = "";
					thisIns.addCountry = "";
					thisIns.addHours = "";
					thisIns.addEmail = "";
					thisIns.addPhone = "";

					thisIns.$http.get('/api/v1/client/')
							.then(function (response) {

								let clients = {};
								for(let x = 0; x < response.data.length; x++){
									clients[response.data[x].id] = response.data[x]
								}

								thisIns.$store.dispatch('updateCompanyClients', clients)
							});

				}).catch(function (error) {
					thisIns.addClientPrompt = false;
					thisIns.$vs.notify({
						title:'Error',
						text: error.response.data,
						color:'danger',
						iconPack: 'feather',
						icon:'icon-alert-circle'})
				});
			}
		},
		created() {
			this.updateClients()
		},
		mounted() {
			this.isMounted = true;
		},
		beforeRouteLeave (to, from, next) {
			if(this.addClientPrompt){
				this.addClientPrompt = false;
				next(false)
			}else{
				next()
			}
		}
	}
</script>
